import mixpanel from "mixpanel-browser"
import * as React from "react"
import { logContentBlockPressEvent } from "../../../utils/events"
import VideoPlayer from './../../../llc/ui/VideoPlayer'
import { useAppContext } from './../../../util'

const { useRef, useEffect } = React

function VideoPlayerBlock({
  video,
  thumbnail,
  // TODO This isn't a colour prop but has other style props on it? It's a 
  // wierd convention to name it color
  color,
  index,
  contentBlockId,
  isAutoPlayEnabled,
}) {
  const { userId, pageId } = useAppContext()
  const instanceRef = useRef({instance: null}).current
  const eleRef = useRef()

  const borderRadius =
    color?.elements?.shape === "Pill"
      ? "16px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

 
  const handlePlay = () => {
    if (instanceRef.instance?.getCurrentTime() === 0) {
      mixpanel.track("Web Video Played", {
        video_type: "hosted",
        distinct_id: userId,
        stack_id: pageId,
      });
    }
  };

  useEffect(() => {
    
    instanceRef.instance = new VideoPlayer({
      path: video,
      poster: thumbnail,
      autoPlay: isAutoPlayEnabled,
    })
    instanceRef.instance.addEventListener('play', handlePlay)
    instanceRef.instance.render(eleRef.current)

    return () => {
      instanceRef.instance.destroy()
    }
  }, [])


  return (
    <div
      ref={eleRef}
      style={{
        width: "100%",
        overflow: "hidden",
        borderRadius: borderRadius,
        position: "relative",
        marginTop: "8px",
      }}
    >
    </div>
  );
}

export default VideoPlayerBlock;
